import { createEventHook } from '@vueuse/core';

import {
  WebSocketClient,
  type Chat,
  type User,
  type UserStatusPayload,
  type UserTypingPayload,
} from '@/shared/api';

const UserEventsController = () => {
  const userPresenceUpdateEventHook = createEventHook<{
    userId: User['id'];
    payload: UserStatusPayload;
  }>();
  WebSocketClient.on('UserStatusEvent', (data) => {
    if (data.userId) {
      userPresenceUpdateEventHook.trigger({ userId: data.userId, payload: data });
    }
  });

  const userTypingEventHook = createEventHook<{
    userId: User['id'];
    payload: UserTypingPayload;
  }>();
  WebSocketClient.on('UserTypingEvent', (data) => {
    if (data.userId) {
      userTypingEventHook.trigger({ userId: data.userId, payload: data });
    }
  });

  const triggerUserTyping = (userId: User['id'], chatId: Chat['id']): void => {
    WebSocketClient.send('UserTypingEvent', { userId, chatId });
  };

  return {
    onUserPresenceUpdate: userPresenceUpdateEventHook.on,
    onUserTyping: userTypingEventHook.on,
    triggerUserTyping,
  };
};

const UserEvents = UserEventsController();

export { UserEvents };
